/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Delete_ConfirmInputs */

const en_us2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pt_br2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

const es_419_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const pt_pt2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

const fr_fr2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_de2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_it2_body_assessment_delete_confirm = /** @type {(inputs: Body_Assessment_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Body_Assessment_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_delete_confirm = /** @type {((inputs?: Body_Assessment_Delete_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Delete_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_delete_confirm(inputs)
	if (locale === "es-419") return es_419_body_assessment_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_delete_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_delete_confirm(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_delete_confirm(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_delete_confirm(inputs)
	return en_us2_body_assessment_delete_confirm(inputs)
});
export { body_assessment_delete_confirm as "body-assessment.delete_confirm" }